/* eslint-disable jsx-a11y/label-has-associated-control */
// Implicit association, see this: https://www.w3.org/WAI/tutorials/forms/labels/#associating-labels-implicitly
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { addDataLayer } from 'lib/GoogleTagManager';

const uiProps = {
  size: 22,
  borderThickness: 2,
  selectedBorderThickness: 7,
};

const Wrapper = styled.label`

  display: flex;
  cursor: pointer;
  &:hover,
  &:focus-within{
    background-color: rgba(0,0,0,0.02);
  }


  &.disabled {
    >label{
      cursor: default;
      &:hover{
        background-color: transparent;
      }
    }
    color: ${({ theme }) => theme.palette.grey[2]};
    .radioUi {
      border-color: ${({ theme }) => theme.palette.grey[3]}!important;
    }
  }
`;

const ChildrenWrapper = styled.div`
  flex-grow:1;
`;

const RadioUi = styled.div`
  width: calc(${uiProps.size}px - ${uiProps.borderThickness * 2}px);
  height: calc(${uiProps.size}px - ${uiProps.borderThickness * 2}px);
  border-radius:100%;
  box-sizing: content-box;
  transition: all .2s;
`;

const RadioUiWrapper = styled.div`
  flex-shrink:0;
  position: relative;
  input {
    position: absolute;
    opacity:0;
    width:0;
  }
  ${RadioUi} {
    border: ${uiProps.borderThickness}px solid ${({ theme }) => theme.palette.grey[1]};
  }


  input:checked + ${RadioUi} {
      width: calc(${uiProps.size}px - ${uiProps.selectedBorderThickness * 2}px);
      height: calc(${uiProps.size}px - ${uiProps.selectedBorderThickness * 2}px);
      border-width: ${uiProps.selectedBorderThickness}px;
      border-color: ${({ theme }) => theme.palette.primary.main};
  }
`;

const RadioButton = ({
  className, value, children, name, checked, disabled, onChange, dataLayer, ...rest
}) => {
  const classes = ['RadioButton'];
  if (disabled) classes.push('disabled');
  if (className) classes.push(className);

  const handleChange = (event) => {
    addDataLayer(dataLayer);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <Wrapper {...{ rest }} className={classes.join(' ')}>
      <RadioUiWrapper className="radioUiWrapper">
        <input
          type="radio"
          name={name}
          value={value}
          defaultChecked={checked}
          disabled={disabled}
          onChange={handleChange}
        />
        <RadioUi className="radioUi" />
      </RadioUiWrapper>
      {children && (
        <ChildrenWrapper className="radioChildrenWrapper">
          {children}
        </ChildrenWrapper>
      )}
    </Wrapper>
  );
};

RadioButton.displayName = 'RadioButton';

RadioButton.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  dataLayer: PropTypes.shape({
    action: PropTypes.string,
    label: PropTypes.string,
  }),
};

RadioButton.defaultProps = {
  className: null,
  checked: false,
  disabled: false,
  dataLayer: null,
};

export default RadioButton;
